import type { LandingPageConfigOptions } from "landing/objects/LandingPageConfig";

export const NameAndMobileOnlyOptions: LandingPageConfigOptions = {
  hidesEmail: true,
};
